import React from 'react';
import css from './ShoutoutOrGreetingsFormFields.module.css';
import DateNeededInputField from '../DateNeededInputField';
import TitleInputField from '../TitleInputField';
import PriceInputField from '../PriceInputField';
import InstructionsFormField from '../InstructionsFormField';
import { FormattedMessage, useIntl } from 'react-intl';
import PersonalizationFormField from '../PersonalizationFormField';
const ShoutoutOrGreetingsFormFields = ({ formId }) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  return (
    <div className={css.offeringBlock}>
      <div className={css.offeringHeader}>
        <h4>
          <FormattedMessage id="ShoutoutOrGreetingsFormFields.sectionHeading" />
        </h4>
      </div>
      <div className={css.formRow}>
        <div className={css.formFld}>
          {/* Title input field */}
          <TitleInputField label={'Title'} id="title" fieldName="title" />
        </div>
        <div className={css.formFld}>
          {/* Price input field */}
          <PriceInputField formId={formId} />
        </div>
      </div>

      {/* Date Needed By Date */}
      <DateNeededInputField
        label={formatMessage({
          id: 'ShoutoutOrGreetingsFormFields.DateNeededInputField.label',
        })}
        fieldName={'dateNeededBy'}
      />

      {/* Personalization */}
      <PersonalizationFormField
        label={formatMessage({
          id: 'ShoutoutOrGreetingsFormFields.PersonalizationFormField.label',
        })}
        placeholder={formatMessage({
          id: 'ShoutoutOrGreetingsFormFields.PersonalizationFormField.placeholder',
        })}
        fieldName={'personalization'}
      />

      {/* Instructions */}
      <InstructionsFormField />
    </div>
  );
};

export default ShoutoutOrGreetingsFormFields;
